import {
  get, post, postupload, postJson, putJson,
} from '@/utils/request';
import { getToken } from '@/utils/auth';

export function ifLogin(tel, pwd, pwdStatus, captchaKey, captcha, unionId) { /** 登录 */
  return get(
    '/regin/login/validate',
    {
      username: tel, password: pwd, pwdStatus, captchaKey, captcha, unionId,
    },
  );
}

export function exhibitionVerifyCodeApi(data) {
  return postJson(
    `/login/code/isExhibitionVerifyCode/${data.username}`,
  );
}

export function loginOut() { /** 登出 */
  return get(
    '/regin/logout',
    { token: getToken() },
  );
}

/** 首页 */
export function homeSalesPer() { /** 查询本月销售额和销售比例 */
  return get(
    '/yesterdayMarket/queryCurrentMonthBySales',
  );
}

export function homeTodaySales() { /** 今日销售额 */
  return get(
    '/yesterdayMarket/queryTodaySales',
  );
}

export function homeYesterdaySales() { /** 昨日销售额，微信支付宝销售额 */
  return get(
    '/yesterdayMarket/queryYesterdaySales',
  );
}
/** 首页 */

/** 弹出框选择数据 */
export function getAccount() { /* 取得运营商数据 */
  return get(
    '/vending/getAccounts',
  );
}
export function getAccountById(id) { /* 取得运营商数据 */
  return get(
    '/vending/getAccountsById', {
      accountName: id,
    },
  );
}

export function getDistributionAccounts(id) { /* 取得经销商数据 */
  return get(
    '/vending/getDistributionAccounts', {
      name: id,
    },
  );
}
export function assaginMachine(id, rId) { /* 提交经销商 */
  return get(
    '/vending/ajax-machine/assaginMachine', {
      machineId: id, toUserId: rId,
    },
  );
}

export function getMachine() { /* 取得机器列表 */
  return get(
    '/vending/getMachine',
  );
}
export function getMachineById(data) { /* 取得机器列表 */
  return get(
    '/vending/getMachineById',
    data,
  );
}

export function copyMachineAndGoods(machineId, copyMachineId) { /* 复制机器 */
  return post(
    `/ajax-machine/copyMachine/${machineId}/${copyMachineId}`,
    { },
  );
}

export function getDiscount() { /* 取得优惠列表 */
  return get(
    '/vending/getDiscount',
  );
}

export function getLocation(id, level) { /* 取得省份 地址选择 */
  return get(
    '/baseareas/selectCity',
    { id, level },
  );
}

export function getType(data) { /* 添加商品的种类 */
  return get(
    '/vending/getType',
    data,
  );
}
/** 弹出框选择数据 */

/** 运营报表 */
export function salesTrendChart(mon) { /* 销量趋势图 */
  return get(
    '/form/monthSalesMap',
    { month: mon },
  );
}
export function sales(mon, id, pro, city, dis) { /* 销量 */
  return get(
    '/form/monthReportForm',
    {
      month: mon, machineId: id, province: pro, city, district: dis,
    },
  );
}
export function goodsTop(mon) { /* 商品TOP10 */
  return get(
    '/form/top10Goods',
    { month: mon },
  );
}
export function machineTop(mon) { /* 机器TOP10 */
  return get(
    '/form/top10Machine',
    { month: mon },
  );
}
export function machineTopDetail(page, mon, id, type) { /* 机器销售详情 */
  return get(
    '/form/top10MachineById',
    {
      page, month: mon, machineId: id, type,
    },
  );
}
export function goodsTopDetail(page, mon, id, type) { /* 商品销售详情 */
  return get(
    '/form/top10GoodsById',
    {
      page, month: mon, goodsId: id, type,
    },
  );
}
/** 运营报表 */

export function noncash(page, name, fieldNumber) { /** 非现金主页 */
  return get(
    '/vending/ajax-payinfo/list',
    { machineIdOrName: name, page, fieldNumber },
  );
}

export function queryMahcineListPageApi(data) {
  return get(
    '/vending/queryMahcineListPage',
    data,
  );
}

export function getMachineListPermissionApi(data) {
  return get(
    '/vending/machineList/permission',
    data,
  );
}

export function addMachine(id, name, accountId, machineTypeName, agreementType, openShoppingCart, shelfCount, status, isSupportFree, remark, fieldNumber) { /** 添加机器 */
  return get(
    '/vending/machine/add',
    {
      machineId: id,
      machineName: name,
      accountId,
      machineTypeName,
      agreementType,
      openShoppingCart,
      shelfCount,
      status,
      isSupportFree,
      remark,
      fieldNumber,
    },
  );
}
export function changeMachine(id, name, accountId, machineType, shelfCount, status, isSupportFree, remark, fieldNumber) { /** 修改机器 */
  return get(
    '/vending/ajax-machine/modify',
    {
      machineId: id,
      machineName: name,
      accountId,
      machineType,
      shelfCount,
      status,
      isSupportFree,
      remark,
      fieldNumber,
    },
  );
}

export function machineDetails(id) { /** 机器详细 */
  return get(
    '/cargoWay/machine/findMachineById',
    { machineId: id },
  );
}
export function machineShelfDetails(page, id, count) { /** 失联、故障、缺货货道 */
  return get(
    '/cargoWay/machine/listOrderStockOrShelfIndex',
    { page, count, machineId: id },
  );
}

export function listOrderStockOrGz(page, id, count) { /** 、故障 */
  return get(
    '/cargoWay/machine/listOrderStockOrGz',
    { page, count, machineId: id },
  );
}

export function listMachineShelfsCargoWays(page, id, range = {}) { /** 设备详情货道 */
  return get(
    '/cargoWay/machine/listMachineShelfsCargoWays',
    { page, machineId: id, ...range },
  );
}
export function listMachineShelfsCargoWay(page, id, range = {}) { /** 货道配置货道 */
  return get(
    '/cargoWay/machine/listMachineShelfsCargoWay',
    { page, machineId: id, ...range },
  );
}

export function paymentDetails(data) { /** 收支详情 3个总金额 */
  return get(
    '/vending/order/detail',
    data,
  );
}

export function paymentAlipay(page, id, st, et) { /** 收支详情 支付宝 */
  return get(
    '/vending/order/detailZfb',
    {
      page, machineId: id, startTime: st, endTime: et,
    },
  );
}
export function paymentWechat(page, id, st, et) { /** 收支详情 微信 */
  return get(
    '/vending/order/detailWx',
    {
      page, machineId: id, startTime: st, endTime: et,
    },
  );
}
export function paymentCash(page, id, st, et) { /** 收支详情 现金 */
  return get(
    '/vending/order/detailXj',
    {
      page, machineId: id, startTime: st, endTime: et,
    },
  );
}
export function machineCode(id) { /** 机器二维码 */
  return get(
    '/vending/machine/detail',
    { machineId: id },
  );
}
export function changeAddress(machineId, searchLocation, latitude, longitude) { /** 修改地址提交按钮 */
  return get(
    '/vending/updateAddress/ajax-list',
    {
      machineId, searchLocation, latitude, longitude,
    },
  );
}

export function replenishment(page, id) { /** 补货主页 */
  return get(
    '/cargoWay/ajax-machine/replenishList',
    { page, machineId: id },
  );
}
export function replenishmentDetails(id) { /** 补货详细页  货道详情详细页 */
  return get(
    '/cargoWay/machine/shelf',
    { machineId: id },
  );
}
export function copyMachine(id, copyId) { /** 拷贝机器 */
  return get(
    '/cargoWay/ajax-machine/doSettingMachine',
    { machineId: id, copyMachineId: copyId },
  );
}
export function fullAll(id) { /** 容量补满 */
  return get(
    '/cargoWay/ajax-machine/fillReplenishMachine',
    { machineId: id },
  );
}
export function sent(id, res) { /** 下发配置 */
  return post(
    '/cargoWay/ajax-machine/pushSetting',
    { machineId: id, array: res },
  );
}

export function deliveryRecord(st, et, page, aId, mId, cardNo) { /** 出货记录主页 */
  const card = cardNo || null;
  return get(
    '/delivery/ajax-list',
    {
      startTime: st, endTime: et, page, accountId: aId, machineId: mId, cardNo: card,
    },
  );
}

export function aisleConfig(page, name) { /** 货道配置主页 */
  return get(
    '/cargoWay/ajax-machine/list',
    { machineIdOrName: name, page },
  );
}
export function changeGoods(data) { /** 货道配置单个详细页的修改商品 */
  return get(
    '/cargoWay/listAllGoods',
    data,
  );
}
export function changeGoodsConfirm(mId, stock, gId) { /** 货道配置单个详细页的修改商品  确定选择 */
  return get(
    '/cargoWay/shelf/goods/modify',
    { machineId: mId, shelfIndex: stock, goodsId: gId },
  );
}
export function changeGoodsDiscount(data) { /** 货道配置单个详细页的优惠 */
  return get(
    '/cargoWay/ajax-machine/settingShelfCoupon',
    data,
  );
}
export function openDoor(mId, stock) { /** 货道配置单个详细页的开门 */
  return get(
    '/cargoWay/ajax-machine/delivery',
    { machineId: mId, shelfIndex: stock },
  );
}
export function openAll(id) { /** 货道配置单个详细页的开门 */
  return get(
    '/cargoWay/ajax-machine/deliveryAll',
    { machineId: id },
  );
}

/** 3个故障 */

export function breakMissing(page, area, machine) { /** 失联 */
  return get(
    '/machine/isOnlines',
    { page, areaId: area, machineId: machine },
  );
}
export function breakStockout(page, area, machine) { /** 缺货 */
  return get(
    '/machine/ajax-machine/unstock/list',
    { page, areaId: area, machineId: machine },
  );
}
export function breakAisle(page, area, machine) { /** 故障 */
  return get(
    '/machine/ajax-machine/broken/list',
    { page, areaId: area, machineId: machine },
  );
}

export function breakDetails(id) { /** 三个故障的单个机器详细信息 */
  return get(
    '/machine/findMachine',
    { machineId: id },
  );
}
/** 3个故障 */

/** 出货详情 */
export function noCashMachine(page, id, st, et) { /** 非现金 */
  return get(
    '/queryPayInfoList',
    {
      currPage: page, startTime: st, endTime: et, machineId: id,
    }, /** 传开始时间 结束时间 */
  );
}
export function noCashAll(id, st, et) { /** 汇总 */
  return get(
    '/queryPayInfoTotal',
    { startTime: st, endTime: et, machineId: id }, /** 传开始时间 结束时间 */
  );
}

export function cashMachine(page, id, st, et) { /** 现金 */
  return get(
    '/queryCashList',
    {
      currPage: page, startTime: st, endTime: et, machineId: id,
    }, /** 传开始时间 结束时间 */
  );
}

export function cashAll(id, st, et) { /** 汇总 */
  return get(
    '/queryCashTotal',
    { startTime: st, endTime: et, machineId: id },
  );
}

/** 出货详情 */

/* 数据分析 */
export function dataAnalysis() {
  return get(
    '/Analysis/findAnalysisQuery',
  );
}
export function dataAnalysis2() {
  return get(
    '/Analysis/findAnalysisQueryBottom',
  );
}
/* 数据分析 */

export function salesStatistics(page, st, et) { /* 销售统计主页 */
  return get(
    '/market/accountDivide',
    { page, startTime: st, endTime: et },
  );
}
export function salesStatisticsDetails(page, startTime, endTime, id) { /* 销售统计详细页 */
  return get(
    '/market/accountDivideMachine',
    {
      page, startTime, endTime, accountId: id,
    },
  );
}

export function goodsList(page, goodsName, accountId, goodsKindId) { /* 商品列表主页 */
  return get(
    '/form/ajax-goods/list',
    {
      page, goodsName, accountId, goodsKindId,
    },
  );
}
export function syncGoodsPrice(data) { /* 同步商品价格 */
  return post(
    '/form/sync/goods/price',
    data,
  );
}
export function goodsListDelete(id) { /* 商品列表主页 */
  return get(
    '/form/ajax-goods/delete',
    { goodsId: id },
  );
}
export function getChangeAlreadyGoods(id) { /* 商品列表修改商品获取信息 */
  return get(
    '/form/ajax-goods/get',
    { goodsId: id },
  );
}

// 商品列表修改商品提交修改
export function submitChangeAlreadyGoods(data) {
  return get(
    '/form/ajax-goods/modify',
    data,
  );
}

// 添加商品上传图片的显示
export function showImg(files) {
  return postupload(
    '/form/file/upload',
    files,
  );
}

/** 会员卡 */
export function vip(page, no, id, status) { /* 会员卡首页 */
  return get(
    '/iccard/ajax-iccard/list',
    {
      cardNo: no, accountId: id, status, page,
    },
  );
}
export function vipDetails(page, id) { /* 会员卡详细页 */
  return get(
    '/iccard/ajax-orderList',
    { page, cardNo: id },
  );
}
export function stopCard(id) { /* 停用 */
  return get(
    '/iccard/ajax-iccard/startCard',
    { id },
  );
}
export function deleteCard(id) { /* 删除 */
  return get(
    '/iccard/ajax-iccard/deleteCard',
    { id },
  );
}
export function repairCard(id, now) { /* 补卡 */
  return get(
    '/iccard/ajax-iccard/repairCard',
    { id, newCardNo: now },
  );
}
export function recharge(cName, uName, tel, money, id) { /* 充值 */
  return get(
    '/iccard/ajax-iccard/updateICCard',
    {
      cardName: cName, userName: uName, mobile: tel, money, id,
    },
  );
}
export function addCard(id, cardNo, cName, uName, tel, balance, type) { /* 添加新卡 */
  return get(
    '/iccard/ajax-iccard/addICCard',
    {
      accountId: id,
      cardNo,
      cardName: cName,
      userName: uName,
      mobile: tel,
      balance,
      cardType: type,
    },
  );
}
/** 会员卡 */

export function addGoods(data) { /* 商品列表的商品添加 */
  return get(
    '/form/ajax-goods/add',
    data,
  );
}

export function importListByPlatGoods(data) { /* 批量导入商品库商品 */
  return postJson(
    '/form/goods/importListPlatgoods',
    data,
  );
}

/** 设置 */
export function setting() { /* 设置首页 */
  return get(
    '/transfer/accountBindWechart',
  );
}
export function notice(id, type) { /* 首页开关 */
  return get(
    '/transfer/ajax-account/notice',
    { noticeId: id, type },
  );
}
export function withdrawal() { /* 申请提现 */
  return get(
    '/transfer/applyCash',
  );
}
export function submitApply(ticket) { /* 点击提现按钮 */
  return get(
    '/transfer/account/submitApply',
    { ticket },
  );
}
export function withdrawalRecord(page, st, et, status) { /* 提现记录 */
  return get(
    '/transfer/ajax-record',
    {
      page, startTime: st, endTime: et, status,
    },
  );
}
export function feedback(code, description, patchca, score, mobile, machineId) { /* 问题反馈提交按钮 */
  return get(
    '/transfer/feedback',
    {
      code, description, patchca, score, mobile, machineId,
    },
  );
}
export function chatRecord() { /* 问题反馈记录 */
  return get(
    '/transfer/findFeedback',
  );
}
export function service(search) { /* 客服内容 */
  return get(
    '/transfer/Customer',
    { search },
  );
}

export function changePassword(old, now) { /* 问题反馈提交按钮 */
  return get(
    '/transfer/UpdatePwd',
    { pwd: old, newPwd: now },
  );
}
export function renew(page) { /* 设备续费 */
  return get(
    '/transfer/ajax-recharge',
    { page },
  );
}
export function changeBind() { /* 更改绑定 */
  return get(
    '/transfer/weixin',
    {},
  );
}
export function renewConfirm(id) { /* 续费进行页面 */
  return get(
    '/transfer/payment',
    { machineIds: id },
  );
}
export function renewSubmit(id, mon, code) { /* 续费页面续费按钮 */
  return get(
    '/transfer/ajax-payment',
    { machineIds: id, month: mon, code },
  );
}

export function renewappid() { /* 获取appid */
  return get(
    '/transfer/queryWxAppid',
  );
}

export function getBillListApi(data) {
  return post(
    '/MerchantPayInfo/ajax-mt/merpayinfo/list',
    data,
  );
}

export function getBillDetailListApi(data) {
  return post(
    '/MerchantPayInfo/ajax-mt/merpayinfo/everydaylist',
    data,
  );
}

export function getPopupSettingStatusApi(data) {
  return get(
    '/popup/setting/status',
    data,
  );
}

export function getRefundOperatorSettingApi() {
  return get(
    '/ajax-account/refund/operatorSetting',
  );
}

export function setRefundOperatorSettingApi(data) {
  return post(
    '/ajax-account/refund/operatorSetting',
    data,
  );
}

export function getUserStatIncomeTodayApi() {
  return get(
    '/home/stat/income/today',
  );
}

export function getUserStatIncomeHistoryApi(data) {
  return get(
    '/home/stat/income/history',
    data,
  );
}

// BASE_API 已包含 /mt，最终请求路径为 /mt/home/stat/workbench/summary。
export function getHomeWorkbenchSummaryApi() {
  return get(
    '/home/stat/workbench/summary',
  );
}

export function unbindAccountTransfersApi(data) {
  return putJson(
    '/transfer/unbindAccountTransfers',
    data,
  );
}



// WEBPACK FOOTER //
// ./src/api/getData.js